import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import Box from "@mui/material/Box";
import Button from "components/Forms/CustomButtons/ButtonTS";

import { useTranslation } from "react-i18next";

interface RejectedModalProps {
  modalOpen: boolean;
  onClose: () => void;
  rejectedReason?: any;
}

export default function RejectedModal({
  modalOpen,
  onClose,
  rejectedReason,
}: RejectedModalProps): JSX.Element {
  const { t } = useTranslation("modals");
  const reasonString = rejectedReason?.reasonForRejection;
  const keys = rejectedReason?.manualApproval
    ? Object?.keys(rejectedReason?.manualApproval)
    : [];
  const rejectedBy = keys?.join(", ");

  return (
    <Dialog
      open={modalOpen}
      fullWidth
      maxWidth="sm"
      scroll="body"
      PaperProps={{
        style: {
          overflowY: "visible",
        },
      }}
      onClose={() => {
        onClose();
      }}
      disableBackdropClick
    >
      <DialogTitle>
        {t("activity-item-rejected-reason")}
        <Button
          justIcon
          simple
          color="tumblr"
          round
          size="sm"
          style={{
            position: "absolute",
            right: "10px",
            top: "10px",
          }}
          onClick={onClose}
        >
          <Close />
        </Button>
      </DialogTitle>

      {reasonString ? (
        <DialogContent
          style={{
            overflowY: "inherit",
            display: "flex",
            flexDirection: "column",
            paddingBottom: 10,
          }}
        >
          <Box
            style={{
              display: "flex",
              gap: "4px",
            }}
          >
            <strong
              style={{
                fontWeight: "bold",
              }}
            >
              {t("rejected-by")}:
            </strong>
            {rejectedBy ?? "N/A"}
          </Box>
          <Box
            style={{
              display: "flex",
              gap: "4px",
            }}
          >
            <strong
              style={{
                fontWeight: "bold",
              }}
            >
              {t("reason")}:
            </strong>
            {reasonString ?? "N/A"}
          </Box>
        </DialogContent>
      ) : (
        <DialogContent
          style={{
            overflowY: "inherit",
            display: "flex",
            flexDirection: "column",
            paddingBottom: 10,
          }}
        >
          <Box display="flex" justifyContent="center">
            <strong>{t("rejection-reason")}</strong>
          </Box>
        </DialogContent>
      )}
    </Dialog>
  );
}
